import { convertToObjById } from "helpers/convertToObject";
import { convertToMapById } from "helpers/convertToMap";
import { addLabelArray } from "helpers/addLabelArray";

export const MOVEMENT_SELECTED = 'MOVEMENT_SELECTED';
export const GET_MOVEMENTS = 'GET_MOVEMENTS';
export const CREATE_MOVEMENT = 'CREATE_MOVEMENT';
export const MOD_MOVEMENT = 'MOD_MOVEMENT';
export const DELETE_MOVEMENT = 'DELETE_MOVEMENT';
export const RESET_MOVEMENT_SELECTED = 'RESET_MOVEMENT_SELECTED';
export const ADD_MOVEMENT_MODE = 'ADD_MOVEMENT_MODE';
export const EDIT_MOVEMENT_MODE = 'EDIT_MOVEMENT_MODE';
export const CHECK_ADD_MOVEMENT_MODE_PERMIT = "CHECK_ADD_MOVEMENT_MODE_PERMIT";
export const DELETE_MOVEMENT_MODE = "DELETE_MOVEMENT_MODE";

const initialState = {
  movements: {},
  movementsArr: [],
  movementSelected: null,
  addMovement: true,
  addMode: false,
  deleteMode: false,
}

export const gasMovementsReducer = (state = initialState, action) => {

  switch (action.type) {

    case ADD_MOVEMENT_MODE:
      return {
        ...state,
        addMode: true,
        deleteMode: false
      }

    case EDIT_MOVEMENT_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: false
      }

    case DELETE_MOVEMENT_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: true
      }
    
    case CHECK_ADD_MOVEMENT_MODE_PERMIT:
      return {
        ...state,
        addMovement: action.payload,
      }

    case GET_MOVEMENTS:
      const filteredMovements = action.payload.filter(movement => movement?.movement.length > 0).map(item => {
        return {
          ...item,
          value: item.id,
          label: `${item.movement} - ${item.type} ${item.withoutNote === 1 ? " (No requiere nota)" : ""}`
        }
      });
      const listMovements = convertToObjById(filteredMovements);
      return {
        ...state,
        movements: listMovements,
        movementsArr: filteredMovements,
      }

    case MOVEMENT_SELECTED:
      return {
        ...state,
        movementSelected: action.payload && state.movements[action.payload]
      }
      
    case RESET_MOVEMENT_SELECTED:
      return {
        ...state,
        movementSelected: null
      }

    case CREATE_MOVEMENT:
      const addingMovement = [action.payload, ...state.movementsArr]
      const newMovements = convertToObjById(addingMovement)
      return {
        ...state,
        movements: newMovements,
        movementsArr: addingMovement,
      }

    case MOD_MOVEMENT:
      const editedMovements = {
        ...state.movements,
        [action.payload.id]: {
          ...state.movements[action.payload.id],
          ...action.payload
        },
      }
      return {
        ...state,
        movements: editedMovements,
        movementsArr: convertToMapById(editedMovements)
      }

    case DELETE_MOVEMENT:
      const dataArray = state.movementsArr.filter(movement => movement.id !== action.payload)
      return {
        ...state,
        movements: convertToObjById(dataArray),
        movementsArr: dataArray,
      }

    default :
      return state
  }
}